import { deepmerge } from '@mui/utils';
import createColor from './createColor';
import sanitizeThemeOptions from './sanitizeThemeOptions';
/**
 * Default options required by all themes.
 * These options can be overriden.
 */
const defaultThemeOptions = {
  typography: {
    subtitle3: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: 0.16 // 1%
    }
  },

  palette: {
    tertiary: createColor('#2595A5'),
    quaternary: createColor('#FFC24D')
  },
  // @ts-ignore additional field for UI Packages docs site
  nprogress: {
    color: '#3399FF'
  }
};

/**
 * Generate default options and sanitize
 * @param options Takes an incomplete theme object and adds the missing parts. Supports options from MUI v3, v4 and v5.
 * @returns A complete, ready-to-use theme options object for MUI v5
 */
export default function createThemeOptions(options) {
  return deepmerge(defaultThemeOptions, sanitizeThemeOptions(options || {}));
}